import { createRoot } from 'react-dom/client';
import { getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import AccommodationSearch from './accommodation-search-form/AccommodationSearch';

import type { JSX } from 'react';

export function AccommodationSearchWidget(props: {
    mountPoint: HTMLDivElement;
    popoverMountPoint: HTMLDivElement;
    shadowRoot: ShadowRoot;
    url: string;
    showChildrenData: boolean;
}): JSX.Element {
    return (
        <WidgetWrapper
            mountPoint={props.mountPoint}
            popoverMountPoint={props.popoverMountPoint ?? props.popoverMountPoint}
            shadowRoot={props.shadowRoot}
        >
            <AccommodationSearch showChildrenData={props.showChildrenData} />
        </WidgetWrapper>
    );
}

class BilberryAccommodationSearch extends BilberryCustomElement {
    protected renderWidget(): void {
        const resultUrl = this.getAttribute('url') ?? '#';
        const showChildrenData = getYesAttribute(this, 'showChildrenData');

        createRoot(this._mountPoint).render(
            <AccommodationSearchWidget
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
                url={resultUrl}
                showChildrenData={showChildrenData}
            />,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-accommodation-search', BilberryAccommodationSearch);
}
